import React from 'react'
import gql from "graphql-tag"
import { Formik, Field } from 'formik'
import * as Yup from 'yup'
import { Modal } from 'antd'

import { showNotification } from '@/state/user-interface'
import { apolloClient } from '@/state/apollo-client'
import { SpinnerButton } from '@/components/common/button'
import { TextField } from '@/components/common/formik'
import { useGlobalContext, GlobalContextProps, useRouter } from '@/components/context'
import { useAppDispatch } from '@/utils/hooks'
import { recordAddUrl } from '@/utils/url'
import formStyle from '@sass/common/form.module.sass'
import { useSaveTeamMutation } from './__gen'


gql`
	mutation saveTeam(
		$name: String!,
		$organisation: ID!,
		$module: ID!
	) {
		team_Update(input: {
			name: $name,
			organisation: $organisation,
			module: $module,
		}) {
			object {
				id
				name
				logo
			}
		}
	}
`

type ModuleType =  NonNullable<GlobalContextProps['currentModule']>

type ValuesType = {
	name: string
}

type Props = {
	module: ModuleType,
	show: boolean,
	callback: () => void,
}

const AddTeam = ({module, show, callback}: Props) => {
	const [mutate, {loading}] = useSaveTeamMutation()
	const dispatch = useAppDispatch()
	const router = useRouter()
	const { organisation, user } = useGlobalContext()
	const text = module.addTeamPhrase || `Enter the name of your ${module.teamWord.toLowerCase()}`
	return (
		<Modal open={show}  footer={null} onCancel={callback}>
			<Formik
				initialValues={{
					name: "",
				}}
				validationSchema={Yup.object().shape({
					name: Yup.string().required('Required'),
				})}
				onSubmit={async (values: ValuesType, actions) => {
					const r = await mutate({variables: {
						name: values.name,
						module: module.id,
						organisation: organisation.id,
					}})
					actions.setSubmitting(false)
					callback()
					dispatch(showNotification({
						content: `Added ${module.teamWord.toLocaleLowerCase()} ${values.name}`,
					}))

					// could potenitally update cache here, but full reload to be safer
					await apolloClient.resetStore()
					router.history.push(recordAddUrl({
						currentTeam: {id: r.data!.team_Update!.object!.id},
						currentModule: {id: module.id}
					}))
				}}
			>
				{props => {
					const { isSubmitting, handleSubmit } = props
					return (
						<div className={formStyle.pageFormContainer}>
							<h5>{text}</h5>
							<form className={formStyle.commonForm} onSubmit={handleSubmit}>
								<Field
									name="name"
									placeholder={`${module.teamWord} name`}
									autoFocus
									component={TextField}
								/>
								<div style={{display: 'flex', justifyContent: 'space-around', width: 200}}>
									<SpinnerButton loading={loading} type="submit">
										Create
									</SpinnerButton>
								</div>
							</form>
						</div>
					)
				}}
			</Formik>
		</Modal>
	)
}

export default AddTeam